import { render, staticRenderFns } from "./vinPlateRepeatReviewPage.vue?vue&type=template&id=440e8a8a&scoped=true"
import script from "./vinPlateRepeatReviewPage.vue?vue&type=script&lang=js"
export * from "./vinPlateRepeatReviewPage.vue?vue&type=script&lang=js"
import style0 from "./vinPlateRepeatReviewPage.vue?vue&type=style&index=0&id=440e8a8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440e8a8a",
  null
  
)

export default component.exports